import { Loader, Menu, Stack } from "@braintrust/braintrust-ui-components";
import { useGetFreelancerPublicProfileQuery } from "@js/apps/freelancer/api";
import { formatPhoneNumber } from "@js/apps/freelancer/components/profnet-profile-page-head/cta-buttons/send-message-button";
import { openSendSmsModal } from "@js/apps/freelancer/components/send-sms-modal";
import type { FreelancerForNodeStaff } from "@js/types/freelancer";

type SendSMSMessageItemProps = {
  freelancerId: number;
};

export const SendSMSMessageItem = ({
  freelancerId,
}: SendSMSMessageItemProps) => {
  const { data: freelancerProfile, isLoading } =
    useGetFreelancerPublicProfileQuery(freelancerId);
  const phoneNumber = (freelancerProfile as FreelancerForNodeStaff | undefined)
    ?.phone_number;

  const isUnavailable = !freelancerProfile || !phoneNumber?.phone_number;
  const showTooltipText = !isLoading && isUnavailable;
  return (
    <Menu.Item
      disabled={isLoading || isUnavailable}
      tooltipText={showTooltipText ? "Phone number unavailable" : undefined}
      onClick={() => {
        if (!freelancerProfile || !phoneNumber) {
          return;
        }

        openSendSmsModal({
          freelancer: freelancerProfile as FreelancerForNodeStaff,
          formattedPhone: formatPhoneNumber(phoneNumber),
        });
      }}
    >
      <Stack direction="row" sx={{ gap: 1, alignItems: "center" }}>
        Send SMS
        {isLoading && <Loader size={16} />}
      </Stack>
    </Menu.Item>
  );
};
